import type { CheckoutReceipts } from '../types';
import {
  amount,
  createCheckoutReceipts,
  createInstalmentReceipt,
  createReceipt,
} from './common';

export const DEBIN_INSTALMENT_FEE_BY_CUSTOMER: CheckoutReceipts = {
  ...createCheckoutReceipts({
    [1]: createInstalmentReceipt(1),
  }),
  instalments_with_end_user_fee: {
    banktransfer: {
      debin: {
        [1]: createReceipt({
          transaction_fees: [
            {
              code: 'INSTALLMENT_FEE',
              amount: amount('ARS', '29.00'),
              percent_value: '3.99',
            },
          ],
          fx: {
            from: 'ARS',
            to: 'ARS',
            rate: '1.0000',
          },
          amount_ext: amount('ARS', '100.00'),
          amount_local_base: amount('ARS', '129.00'),
          amount_local_total: amount('ARS', '152.00'),
          local_taxes: [
            { code: 'AR_IG_IBP', amount: amount('ARS', '0.00'), rate: '0.0000' },
            { code: 'AR_NON_RESIDENT_IGBP', amount: amount('ARS', '1.00'), rate: '0.0100' },
            { code: 'AR_IIBB_DF', amount: amount('ARS', '2.00'), rate: '0.0200' },
            { code: 'AR_IVA', amount: amount('ARS', '21.00'), rate: '0.2100' },
            { code: 'INSTALLMENT_FEE', amount: amount('ARS', '21.00'), rate: '0.2100' },
          ],
          installments_plan_token: 'fee-q3asdjahsdkja',
          instalments_plan: {
            instalments: 1,
            amount_partial_first: amount('ARS', '152.00'),
            amount_partial_other: amount('ARS', '152.00'),
          },
        }),
      },
    },
  },
};
